import { Swiper } from "swiper11";
import type { CreatedThumbsOpts } from "@common/types/vendor";
import type { AutoplayOptions, SwiperCustomSwitch } from "swiper11/types";

export function autoInitSwiper({ page, marker, groupName, pane, controls, swiperOtions }: AutoSwiper): void {
  const PAGE_DOM = $(page);
  const SWIPER_GROUP = PAGE_DOM.find(marker);
  if (!PAGE_DOM.length || !SWIPER_GROUP.length) return;
  const temp: any = {};

  function setControl(control: any, select: string) {
    const temp: any = {};
    for (const key in control) {
      if (key == "pagination") {
        temp[key] = {
          el: select + " " + control[key],
          clickable: swiperOtions?.ClickAble ?? false,
        };
      } else if (key == "navigation") {
        temp[key] = {
          nextEl: select + " " + control[key] + "-next",
          prevEl: select + " " + control[key] + "-prev",
        };
      }
    }
    return temp;
  }
  SWIPER_GROUP.each(function (i, el) {
    // i = i + 1;
    const SWIPER_SELECT = page + " " + marker + "_" + i;
    const SWIPER_CLASS = (marker + "_" + i).replace(".", "");
    $($(el)).addClass(SWIPER_CLASS);
    const res = JSON.stringify(controls) !== "{}" ? setControl(controls ?? {}, SWIPER_SELECT) : {};
    temp[SWIPER_CLASS] = new Swiper(SWIPER_SELECT + " .swiper", {
      ...swiperOtions,
      ...res,
    });
    if (pane && pane != "") {
      // const EL = $(pane)[i] as any;
      const EL = $(temp[SWIPER_CLASS].el).parents(".tab-pane")[0] as any;
      EL.swiperList = EL.swiperList || [];
      EL.swiperList.push(temp[SWIPER_CLASS]);
    }
  });

  if (!window.swiperGroup || !groupName) return;
  window.swiperGroup[groupName] = {
    ...window.swiperGroup[groupName],
    ...temp,
  };
}
/* 
update By chw 2025-4-17
*/
export function createdThumbs(swiper: Swiper, thumbsSelect: string | HTMLElement, opts?: CreatedThumbsOpts): Promise<Swiper> | undefined {
  const slideList = $(swiper.el).find(".swiper-slide");
  const container = $(thumbsSelect as any); // 缩略图Swiper
  const wrapper = $("<div class='swiper-wrapper'></div>");
  if (!slideList.length || !container.length) return;
  const tempFragment = document.createDocumentFragment();
  slideList.each((_i, item) => {
    const target = $(item).find(opts?.cloneTarget || ".img-box");
    const clone = $(target).clone().removeClass("zoomSl")[0];

    $(clone).find("a[data-fancybox]").contents().unwrap();
    const slide = $(`<div class='swiper-slide'></div>`);
    slide.append(clone);
    tempFragment.appendChild(slide[0]); // Append the slide to the fragment
  });

  wrapper.append(tempFragment);
  container.append(wrapper);
  return new Promise((res, rej) => {
    try {
      const createdSwiper = new Swiper(container[0], opts?.swiperOptions ?? {});
      const createType = opts?.type || "thumbs";
      switch (createType) {
        case "controller":
          try {
            createdSwiper.controller.control = swiper;
          } catch (error) {
            console.warn("请为创建的Swiper实例添加‘Controller’模块！！！", error);
          }
          try {
            swiper.controller.control = createdSwiper;
          } catch (error) {
            console.warn("请为主Swiper实例添加‘Controller’模块！！！", error);
          }
          break;
        case "thumbs":
          swiper.thumbs.swiper = createdSwiper;
          swiper.on("afterInit", (S) => {
            S.thumbs.init();
            S.thumbs.update(true);
            S.update();
          });
          swiper.on("slideChange", (S) => {
            const thumbs = S.thumbs.swiper;
            const currentIdx = thumbs.params.loop ? S.activeIndex : S.realIndex;
            thumbs.slideTo(currentIdx, 500, false);
          });
          break;
        case "none":
          break;
        default:
          break;
      }
      res(createdSwiper);
    } catch (error) {
      rej(error);
    }
  });
}

export class SwiperVideo {
  private _Swiper: Swiper | undefined = undefined;
  constructor(swiper: Swiper) {
    this._Swiper = swiper;
    if (!this._Swiper) throw Error("swiper can't not be empty.");
    this._addEventListener();
  }
  private _addEventListener() {
    this._Swiper!.on("init", (S) => {
      S.autoplay.stop();
      const videoList = $(S.slides).find("video");
      if (!videoList.length) return;
      videoList.on("ended", () => {
        S.slideNext();
        S.autoplay.start();
      });
    });
    this._Swiper!.on("slideChangeTransitionStart", (S) => {
      $(S.slides).each((_i, item) => {
        const V = this.getVideo(item);
        if (V) V[0].pause();
      });
      const currentSlide = S.slides[S.activeIndex];
      const video = this.getVideo(currentSlide);
      if (video) {
        S.autoplay.stop();
        video[0].play();
      } else {
        S.autoplay.start();
      }
    });
  }
  getVideo(target: HTMLElement | Element) {
    const res = $(target).find("video");
    if (res && res.length) {
      return res;
    } else {
      return false;
    }
  }
}

export const injectToChar = () => {
  Swiper.prototype.toChar = toChar;
};
export const injectSwitchSlide = () => {
  Swiper.prototype.customSwitchSlide = customSwitchSlide;
};
export const injectSwiperSwitch = () => {
  Swiper.prototype.SwiperSwitch = (swiper: Swiper, config?: SwiperCustomSwitch) => new SwiperSwitch(swiper, config);
};
function toChar<T>(num: T): T {
  let res: T;
  if (typeof num === "number" && num < 10) {
    res = ("0" + num) as T;
  } else {
    res = num as T;
  }
  return res as T;
}
// function customSwitchSlide(swiper: Swiper, activeClassOrConfig?: string | SwiperCustomSwitch, extraConfig?: SwiperCustomSwitch): void {
//   const defaultActiveClass = "custom-active";
//   let activeClass: string;
//   let config: SwiperCustomSwitch;
//   let currentIdx: undefined | number = undefined;
//   const autoplay = swiper.params.autoplay as AutoplayOptions;
//   const delay = autoplay?.delay ?? 3000;
//   const pauseOnMouseEnter = autoplay.pauseOnMouseEnter;
//   let timer: NodeJS.Timeout;
//   if (typeof activeClassOrConfig === "object" && activeClassOrConfig !== null) {
//     config = activeClassOrConfig;
//     activeClass = defaultActiveClass;
//   } else {
//     activeClass = activeClassOrConfig || defaultActiveClass;
//     config = extraConfig || {};
//   }
//   if (swiper.params.loop && swiper.slides.length > Number(swiper.params.slidesPerView)) {
//     swiper.params.slideActiveClass = activeClass;
//     return;
//   } else {
//     swiper.params.loop = false;
//   }
//   //@ts-ignore
//   if (autoplay && autoplay.enabled) {
//     swiper.autoplay.stop();
//   }
//   const startTimer = () => {
//     if (!timer) {
//       timer = setInterval(() => {
//         const currentIdx = swiper.slides.findIndex((i) => $(i).hasClass(activeClass));
//         const nextIdx = currentIdx + 1 === swiper.slides.length ? 0 : currentIdx + 1;
//         switchActive(swiper.slides, nextIdx);
//       }, delay);
//     }
//   };
//   const switchActive = (slides: HTMLElement[], activeIdx: number) => {
//     if (currentIdx === activeIdx) return;
//     currentIdx = activeIdx;
//     $(slides).removeClass(activeClass);
//     $(slides[activeIdx]).addClass(activeClass);
//     swiper.slideTo(activeIdx);
//     if (config.on && config.on.active && typeof config.on.active === "function") {
//       config.on.active(activeIdx, slides[activeIdx], timer);
//     }
//   };
//   switchActive(swiper.slides, swiper.realIndex);
//   swiper.on("click", (s) => {
//     switchActive(s.slides, s.clickedIndex);
//   });
//   startTimer();
//   if (pauseOnMouseEnter) {
//     swiper.el.addEventListener("mouseenter", () => {
//       clearInterval(timer);
//     });
//     swiper.el.addEventListener("mouseleave", () => {
//       startTimer();
//     });
//   }
// }

class SwiperSwitch {
  swiper: Swiper;
  activeClass: string = "custom-active";
  config: SwiperCustomSwitch;
  autoplay?: AutoplayOptions = undefined;
  delay = 3000;
  pauseOnMouseEnter?: boolean = undefined;
  timer: NodeJS.Timeout | null = null;
  #prevIndex = 0;
  #currentIndex = 0;
  #transitioning = false;
  constructor(swiper: Swiper, extraConfig?: SwiperCustomSwitch) {
    if (!swiper) {
      throw Error("No Swiper Instance will be inject!");
    }
    this.swiper = swiper;
    this.config = extraConfig || {};
    const originalSwiperParams = this.swiper.params;
    this.autoplay = originalSwiperParams.autoplay as AutoplayOptions;
    if (this.autoplay) {
      this.delay = this.autoplay.delay ?? 3000;
      this.pauseOnMouseEnter = this.autoplay.pauseOnMouseEnter;
    }
    this.#init();
    this.#bindEvent();
  }

  #init() {
    if (!this.swiper) return;
    // @ts-ignore
    if (this.swiper.initialized) {
      throw Error("Please Init this ClassFunction before swiper init");
    }
    const originalSwiperParams = this.swiper.params;
    if (originalSwiperParams.loop && this.swiper.slides.length > Number(originalSwiperParams.slidesPerView)) {
      // 达到可以正常loop的情况
      originalSwiperParams.slideActiveClass = this.activeClass;
      return;
    } else {
      // 无法正常loop
      this.swiper.params.loop = false;
    }
  }

  #bindEvent() {
    const _navigation = () => {
      if (!this.swiper.navigation) return;
      this.swiper.on("init", (s) => {
        const { prevEl, nextEl } = s.navigation;
        this.swiper.navigation.destroy();
        $(nextEl).on("click", () => {
          this.handleSwitch(s.slides, this.#currentIndex + 1);
        });
        $(prevEl).on("click", () => {
          this.handleSwitch(s.slides, this.#currentIndex - 1);
        });
      });
    };

    const _click = () => {
      this.swiper.on("click", (s) => {
        this.handleSwitch(s.slides, s.clickedIndex);
      });
    };

    const _init = () => {
      this.swiper.on("init", (s) => {
        const idx = s.params.loop ? s.activeIndex : s.realIndex;
        this.handleSwitch(s.slides, idx);
      });
    };

    const _autoplay = () => {
      // @ts-ignore
      if (this.autoplay && this.autoplay.enabled) {
        this.swiper.on("init", () => {
          this.swiper.autoplay.stop();
        });
        this.setTimer();
        if (this.pauseOnMouseEnter) {
          this.swiper.el.addEventListener("mouseenter", () => {
            if (this.timer) {
              this.setTimer(true);
            }
          });
          this.swiper.el.addEventListener("mouseleave", () => {
            this.setTimer();
          });
        }
      }
    };

    _navigation();
    _click();
    _autoplay();
    _init();
  }

  setTimer(remove: boolean = false) {
    if (remove && this.timer) {
      clearInterval(this.timer);
      this.timer = null;
      return;
    }
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.timer = setInterval(() => {
      const currentIdx = this.swiper.slides.findIndex((i) => $(i).hasClass(this.activeClass));
      const nextIdx = currentIdx + 1 === this.swiper.slides.length ? 0 : currentIdx + 1;
      this.handleSwitch(this.swiper.slides, nextIdx);
    }, this.delay);
  }

  handleSwitch(slides: HTMLElement[], activeIdx: number) {
    if (this.#currentIndex === activeIdx) return;
    this.#prevIndex = this.#currentIndex;
    if (this.config.waitForTransition) {
      if (!this.#transitioning) {
        this.setTimer(true);
        this.#transitioning = true;
      } else {
        return;
      }
    }
    // Before switching, trigger beforeSwitch event if defined
    if (this.config.on && this.config.on.beforeSwitch && typeof this.config.on.beforeSwitch === "function") {
      this.config.on.beforeSwitch(slides[this.#prevIndex], slides[activeIdx], this.timer); // Ensure beforeSwitch is completed before proceeding
    }
    if (this.config.waitForTransition && this.#transitioning) {
      this.#switchToActive(slides, activeIdx);
    } else {
      this.#switchToActive(slides, activeIdx);
    }
  }
  #switchToActive(slides: HTMLElement[], activeIdx: number) {
    // Reset timer if autoplay is enabled
    //@ts-ignore
    if (this.autoplay && this.autoplay.enabled) {
      this.setTimer();
    }
    // Boundary conditions for activeIdx
    if (activeIdx >= slides.length) {
      activeIdx = 0;
    }
    if (activeIdx < 0) {
      activeIdx = slides.length - 1;
    }
    this.#currentIndex = activeIdx;
    $(slides).removeClass(this.activeClass);
    $(slides[activeIdx]).addClass(this.activeClass);
    this.swiper.slideTo(activeIdx);
    this.#transitioning = false;
    // Trigger the active event
    if (this.config.on && this.config.on.active && typeof this.config.on.active === "function") {
      this.config.on.active(activeIdx, slides[activeIdx], this.timer);
    }
  }
}

function customSwitchSlide(swiper: Swiper, activeClassOrConfig?: string | SwiperCustomSwitch, extraConfig?: SwiperCustomSwitch): void {
  const defaultActiveClass = "custom-active";
  let activeClass: string;
  let config: SwiperCustomSwitch;
  let currentIdx: undefined | number = undefined;
  const autoplay = swiper.params.autoplay as AutoplayOptions;
  const delay = autoplay?.delay ?? 3000;
  const pauseOnMouseEnter = autoplay.pauseOnMouseEnter;
  let timer: NodeJS.Timeout;
  if (typeof activeClassOrConfig === "object" && activeClassOrConfig !== null) {
    config = activeClassOrConfig;
    activeClass = defaultActiveClass;
  } else {
    activeClass = activeClassOrConfig || defaultActiveClass;
    config = extraConfig || {};
  }
  if (swiper.params.loop && swiper.slides.length > Number(swiper.params.slidesPerView)) {
    swiper.params.slideActiveClass = activeClass;
    return;
  } else {
    swiper.params.loop = false;
  }
  //@ts-ignore
  if (autoplay && autoplay.enabled) {
    swiper.autoplay.stop();
  }
  const startTimer = () => {
    if (!timer) {
      timer = setInterval(() => {
        const currentIdx = swiper.slides.findIndex((i) => $(i).hasClass(activeClass));
        const nextIdx = currentIdx + 1 === swiper.slides.length ? 0 : currentIdx + 1;
        switchActive(swiper.slides, nextIdx);
      }, delay);
    }
  };
  const switchActive = (slides: HTMLElement[], activeIdx: number) => {
    if (currentIdx === activeIdx) return;
    currentIdx = activeIdx;
    $(slides).removeClass(activeClass);
    $(slides[activeIdx]).addClass(activeClass);
    swiper.slideTo(activeIdx);
    if (config.on && config.on.active && typeof config.on.active === "function") {
      config.on.active(activeIdx, slides[activeIdx], timer);
    }
  };
  switchActive(swiper.slides, swiper.realIndex);
  swiper.on("click", (s) => {
    switchActive(s.slides, s.clickedIndex);
  });
  startTimer();
  if (pauseOnMouseEnter) {
    swiper.el.addEventListener("mouseenter", () => {
      clearInterval(timer);
    });
    swiper.el.addEventListener("mouseleave", () => {
      startTimer();
    });
  }
}
